const CONSTANTS = {
  ERROR_DOWNLOAD_FILE_COMMENT: `Falha no processo de download.
    Por favor, tente novamente mais tarde. Caso o problema persista, contate o seu atendimento.`,
  INFO_DISABLE_NOTIFICAION:
    'Para desabilitar a notificação é necessário que os comentários da demanda estejam sinalizados como "lido"',
  // tslint:disable-next-line: max-line-length
  INFO_OPEN_DEMANDS_OPEN_IMPLANTATION:
    'Demandas de abertura e implantação não podem ser combinadas com demais eventos. Para solicitação de abertura e implantação, abrir uma nova demanda.',
  UPDATE_DO_SUCCESS: 'Alteração realizada com sucesso',
  UPDATE_DO_RUN: 'solicitação em andamento',
  UPDATE_DO_SUCCESS_ISERVICES: 'Alteração do iService realizada com sucesso',
  DISCARD_CHANGES:
    'Ao voltar sem salvar, as alterações não serão realizadas. Deseja descartar as alterações?',
  ERROR_LOAD_PORTFOLIOS: 'Não foi possível carregar as carteiras',
  ERROR_LOAD_PORTFOLIOS_US: 'Portfolio not found. Please, try again.',
  ERROR_LOAD_RESULT: 'Resultado não encontrado. Tente novamente.',
  ERROR_LOAD_RESULT_US: 'Result not found. Please, try again.',
  ERROR_LOAD_MENUS: 'Não foi possível carregar os menus',
  ERROR_LOAD_MANAGER_DESCRIPTION: 'Não foi possível carregar a descrição do gestor',
  ERROR_LOAD_MANAGER_DESCRIPTION_US: 'Error loading manager details',
  ERROR_GET_FUNCIONAL_FROM_LOCALE: 'Não foi possível localizar a funcional',
  ERROR_VALIDATION_OPERATION_DATE: 'Não foi possível validar a data de operação',
  ERROR_PORTFOLIO_NOT_FOUND: 'Carteira não encontrada',
  ERROR_ISERVICES: 'Não foi possível alterar o perfil do iService',
  GLOBAL: {
    ERROR_ACTION_UPDATE:
      'Ocorreu um erro e sua alteração não foi realizada. Caso o problema persista, favor contatar seu canal de atendimento',
    DISCARD_CHANGES: 'Deseja descartar as alterações?',
    YES: 'Sim',
    NO: 'Não',
    OK: 'Ok',
  },
  ALERT_SEARCH_TYPE: 'Selecione o tipo de busca',
  INFO_DISABLE_OCC_TYPE_OPEN_IMPL:
    'Demandas de abertura e implantação não podem ser combinadas com demais eventos. Para solicitação de abertura e implantação, abrir uma nova demanda.',
  INFO_REQUIRED_PORTFOLIO:
    'Para prosseguir com a abertura da demanda, o campo fundo/carteira deve ser preenchido.',
  INFO_DISABLE_NEW_EVENTS:
    'Demandas de abertura e implantação não podem ser combinadas com demais eventos. Para solicitação de novos eventos, abrir uma nova demanda.',
  MNEMONIC_CETIP_TOOLTIP: `Para CFF (fundo fechado), o campo possui 10 caracteres.
    Para CFA (fundo aberto), o campo possui 11 caracteres.`,
}

const CRYPTO_KEYS = {
  CRYPTO_PASS_PHRASE: 'en4_integracao_ok4_controle_ativos_site',
}

const APP_SETTINGS = {
  COD_SITE: 2,
}

const ROUTES = {
  USERS: '/usuarios',
}

// verificar retorno API quando estiver pronta e atualizar
const STATUS = {
  br: {
    'EM ELABORAÇÃO': 'Em Elaboração',
    CANCELADO: 'Cancelado',
    'EM APROVAÇÃO': 'Em Aprovação',
    'EM APROVAÇÃO INTRAG': 'Em Aprovação Fiduciária',
    INTRAG: 'Adm. Fiduciária',
  },
  us: {
    'EM ELABORAÇÃO': 'In Preparation',
    CANCELADO: 'Canceled',
    'EM APROVAÇÃO': 'Under Fiduciary Approval',
    INTRAG: 'Fiduciary Adm.',
  },
}

const MESSAGES = {
  forward: {
    br: `Boleta incluída no status [${STATUS.br['EM APROVAÇÃO']}] com sucesso`,
    us: `Ticket successfully added to [${STATUS.us['EM APROVAÇÃO']}] status`,
  },
  fowardIntrag: {
    br: `Boleta incluída no status [${STATUS.br['EM APROVAÇÃO INTRAG']}] com sucesso`,
    us: `Ticket successfully added to [${STATUS.us['EM APROVAÇÃO INTRAG']}] status`,
  },
  save: {
    br: `Boleta incluída no status [${STATUS.br['EM ELABORAÇÃO']}] com sucesso`,
    us: `Ticket successfully included in [${STATUS.us['EM ELABORAÇÃO']}] status`,
  },
  cancel: {
    br: `Boleta incluída no status [${STATUS.br['CANCELADO']}] com sucesso`,
    us: `Ticket successfully included in [${STATUS.us['CANCELADO']}] successfully`,
  },
}

export { CONSTANTS, CRYPTO_KEYS, APP_SETTINGS, ROUTES, MESSAGES, STATUS }
